import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, Platform } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { HttpChatProvider } from '../../../providers/http-chat';
import { PhotoAction, _PhotoAction } from '../../../actions/photo.action';
import { ChatAction } from '../../../actions/chat.action';
import { Subscription } from 'rxjs/Subscription';
import { AbstractPage } from '../../_com/abstract-page';
import { LoadingService } from '../../../providers/loading-service';
import { PhotoRequestConfirmPage } from '../confirm/photo-request-confirm';
import Utils from '../../../_com/utils';
import _ from 'underscore';

/**
 * Generated class for the PhotoRequestSelectionPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-photo-request-selection',
  templateUrl: 'photo-request-selection.html',
})
export class PhotoRequestSelectionPage extends AbstractPage{

	data = {};
	photos = [];
	photoChecks = {};
	memo = "";

  captureDatas$:Subscription;
  captureData$:Subscription;

  photoAction:_PhotoAction;

  constructor(public navCtrl: NavController, public navParams: NavParams, private httpChatProvider:HttpChatProvider, private tmpPhotoAction:PhotoAction, private chatAction:ChatAction, private alertController:AlertController, private pv:PhotoViewer, private pl:PhotoLibrary, private plt:Platform, private loadingService:LoadingService, private toastController:ToastController,
) {
    super();
    this.photoAction = this.tmpPhotoAction.getInstance();

  
  	this.takePictureDataSubscribe();

    this.pl;
    this.pv;
    this.plt;
  }

  ionViewDidLoad() {
    this.data = this.navParams.data["Reserve"];
    this.memo = this.data["photoRequest"]["message"];
    this.refreshPhoto();
  }

  /**
   * 対象写真一覧の最新化
   */
  refreshPhoto(){
    console.log('refreshPhoto', this.data["id"]);
    this.httpChatProvider.getListHasPhotos([this.data["id"]]).subscribe((data2)=>{
      this.photos = data2.data;
    })
  }

  /**
   * 写真の追加アップロード
   */
  uploadAdditionalPhoto(){

    this.uploadReady = [];
    this.photoAction.photoSelectMultiple({needModal:true, screen:"photo_request_selection"});
  }

  /**
   * 写真データ取得時イベント
   */
  uploadReady = [];
  takePictureDataSubscribe(){

    var self = this;

    /* アルバム選択(単数) */
    this.captureDatas$ = this.photoAction.captureDatas$.subscribe((imageDatas)=>{
      if(self.photoAction.getScreen() != "photo_request_selection") return;
      this.uploadReady = imageDatas;
      this.pictureSend();
    });

    /* 写真選択(複数枚) */
    this.captureData$ = this.photoAction.captureData$.subscribe((imageData)=>{
      if(self.photoAction.getScreen() != "photo_request_selection") return;
      this.uploadReady = [imageData];
      this.pictureSend();
    });
  }

  /**
   * 写真データ送信
   */
  pictureSend(){

    this.loadingService.present("");

    var updateData = {
      room_id:this.data["id"],
      room_type:"reserve",
      message:"",
      imageData:this.uploadReady[0],
    }

    this.chatAction.savePicture(updateData).subscribe((data)=>{

      if(data.data){
        this.uploadReady.shift();
        if(this.uploadReady.length > 0){
          this.pictureSend();
        } else {
          this.toast(this.toastController, "写真のアップロードが完了しました");
          this.refreshPhoto();          
        }
      } else {
        this.loadingService.dissmiss();
        this.alert(this.alertController, "一部写真のアップロードにしました。ご確認お願いします。");
      }
    });
  }

  /**
   * 予約日付
   */
  getReserveDate(d){

    if(_.isEmpty(d))return;
    d = d.datetime.date;
    return Utils.date.format(Utils.date.getDateFromHyphen(d), "yyyy年M月d日(EEEE)");
  }

  /**
   * 次画面への遷移可能判定
   */
  canGo(){
  	return !_.chain(this.photoChecks)
  		.filter((data)=>{
  			return (data == true);
  		})
  		.isEmpty()
  		.value();
  }

  /**
   * 確認画面へ
   */
  goConfirm(){

    this.navCtrl.push(PhotoRequestConfirmPage, {data:this.data, photoChecks:this.photoChecks, photos:this.photos, memo:this.memo});
  }

  /**
   * subscription破棄
   */
  ngOnDestroy(){
    this.captureData$.unsubscribe();
    this.captureDatas$.unsubscribe();
    this.photoAction = null;
  }
}


// WEBPACK FOOTER //
// ./src/pages/photo-request/selection/photo-request-selection.ts